import React, { ChangeEvent } from "react";
import { useFormContext } from "react-hook-form";
import FormTextField from "../../Common/FormTextField";
import { getFieldPath } from "../../Common/SchemaUtils";

type HtmlEvent = ChangeEvent<HTMLTextAreaElement | HTMLInputElement>;

const IntFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
}> = ({ extractionId, extractionPath, label }) => {
  const { control } = useFormContext();
  const handleChange = (e: HtmlEvent, fieldOnChange: (e: any) => void) =>
    fieldOnChange(Number(e.target.value.replace(/\D/, "")));
  return (
    <FormTextField
      size="small"
      label={label}
      key={getFieldPath([extractionId, extractionPath])}
      name={`extraction.${getFieldPath([extractionId, "value", extractionPath])}`}
      handleChange={handleChange}
      control={control}
      type="number"
      rules={{ valueAsNumber: true }}
    />
  );
};

export default IntFormFields;
